import { Navigate, Route, Routes } from 'react-router';

import GeofenceEditingSidebarContainer from '../components/geofence/GeofenceEditingSidebar.container';
import GeofenceCreationSidebarContainer from '../components/geofence/GeofenceSidebar.container';
import POICreationSidebarContainer from '../components/poi/POICreationSidebar.container';
import POIEditSidebarContainer from '../components/poi/POIEditSidebar.container';
import { Map } from '../map/Map';
import POIPage from '../table/POIPage';
import { Routing } from './Routing';

export const Sidebars = () => (
    <Routes>
        <Route path={Routing.geofenceCreate} element={<GeofenceCreationSidebarContainer />} />
        <Route path={Routing.geofenceEdit} element={<GeofenceEditingSidebarContainer />} />
        <Route path={Routing.poiCreate} element={<POICreationSidebarContainer />} />
        <Route path={Routing.poiEdit} element={<POIEditSidebarContainer />} />
        <Route path={Routing.poiList} element={null} />
        <Route path={'/*'} element={null} />
    </Routes>
);

export const Router = () => (
    <Routes>
        <Route path={Routing.geofenceCreate} element={<Map />} />
        <Route path={Routing.geofenceEdit} element={<Map />} />
        <Route path={Routing.poiCreate} element={<Map />} />
        <Route path={Routing.poiEdit} element={<Map />} />
        <Route path={Routing.poiList} element={<POIPage />} />
        <Route path={'/*'} element={<Navigate to={Routing.poiList} />} />
    </Routes>
);

export default Router;
